/* unplugin-vue-components disabled */import { render } from "./DecorativeCorners.vue?vue&type=template&id=5d43fdc7&scoped=true"
const script = {}

import "./DecorativeCorners.vue?vue&type=style&index=0&id=5d43fdc7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@6.0.0-dev.20250807__webpack@5.105.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d43fdc7"]])

export default __exports__